import type {
  JsonApiDocument,
  JsonApiResource,
  JsonApiResourceIdentifier
} from 'src/types/json-api'

export function includedRelation<T extends JsonApiResource>(
  jsonApiRes: JsonApiDocument<JsonApiResource>,
  relationshipName: string
): T | null {
  const rel = jsonApiRes.data.relationships[relationshipName]?.data
  return findIncluded<T>(jsonApiRes.included, rel) || null
}

export function includedRelationIncluded<T extends JsonApiResource>(
  jsonApiDoc: JsonApiDocument,
  jsonApiRes: JsonApiResource,
  relationshipName: string
): T | null {
  const rel = jsonApiRes.relationships[relationshipName]?.data
  return !Array.isArray(rel) ? findIncluded<T>(jsonApiDoc.included, rel) || null : null
}

export function includedRelationIncludedArray<T extends JsonApiResource>(
  jsonApiDoc: JsonApiDocument,
  jsonApiRes: JsonApiResource,
  relationshipName: string
): T[] {
  const refs = jsonApiRes.relationships[relationshipName]?.data
  return Array.isArray(refs)
    ? (refs
        .map((rel?: JsonApiResourceIdentifier) => findIncluded<T>(jsonApiDoc.included, rel))
        .filter(item => item !== null) as T[])
    : []
}

export function includedRelations<T extends JsonApiResource>(
  jsonApiRes: JsonApiDocument<JsonApiResource>,
  relationshipName: string
): T[] {
  const refs = jsonApiRes.data.relationships[relationshipName]?.data
  const included = (jsonApiRes.included || []) as JsonApiResource[]
  return Array.isArray(refs)
    ? (refs
        .map((rel?: JsonApiResourceIdentifier) => findIncluded<T>(included, rel))
        .filter(item => item !== null) as T[])
    : []
}

export function includedRelationsArraySingle<T extends JsonApiResource>(
  jsonApiRes: JsonApiDocument<JsonApiResource[]>,
  relationshipName: string
): T[] {
  const refs = jsonApiRes.data[0].relationships[relationshipName]?.data
  const included = (jsonApiRes.included || []) as JsonApiResource[]
  return Array.isArray(refs)
    ? (refs
        .map((rel?: JsonApiResourceIdentifier) => findIncluded<T>(included, rel))
        .filter(item => item !== null) as T[])
    : []
}

export function findIncluded<T extends JsonApiResource>(
  included?: JsonApiResource[],
  rel?: JsonApiResourceIdentifier
): T | null {
  return rel && included
    ? (included.find(n => n.id === rel.id && n.type === rel.type) as T) || null
    : null
}
